import React from "react";
import SleepingPlan from "./SleepingPlan";
import VillaDescription from "./VillaDescription";
import VillaFeatures from "./VillaFeatures";

const VillaDetails = ({ villa }) => {
  return (
    <div className="flex flex-col lg:px-6 md:px-3 lg:pt-6 md:pt-3">
      <VillaDescription description={villa?.icerik} />
      <SleepingPlan sleepingPlans={villa?.sleepingPlans} />
      {villa?.onecikan && <VillaFeatures features={villa?.onecikan} />}
    </div>
  );
};

export default VillaDetails;
